module.exports = __webpack_public_path__ + "img/20-consultas-cadastros-lista.6ffa5ff3.png";